import { AutogenModelOpenItemCollectionsLookup, AutogenRowOpenItemCollectionsLookup } from "./autogen/AutogenModelOpenItemCollectionsLookup";

export class ModelOpenItemCollectionsLookup extends AutogenModelOpenItemCollectionsLookup<RowOpenItemCollectionsLookup> {
	constructor() {
		super(RowOpenItemCollectionsLookup);
	}
}

export class RowOpenItemCollectionsLookup extends AutogenRowOpenItemCollectionsLookup {
}